/**
 * Application Entry Point
 * 
 * Wraps the app with AuthProvider for authentication context
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AuthProvider } from './contexts/AuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import { initUiVersion } from './config/uiVersion';

// When the MSAL popup redirects back to this origin, the auth response rides in the
// URL (e.g. "#code=...&state=..."). Mounting the app here could overwrite that before
// MSAL reads it (hash_empty_error). In that case, don't mount the app — leave the URL
// intact so MSAL can read the response.
const _h = window.location.hash + window.location.search;
const _isAuthResponse = /[#&?](code|error|id_token|access_token)=/.test(_h);

const root = ReactDOM.createRoot(document.getElementById('root'));

if (_isAuthResponse) {
  document.getElementById('root').innerHTML =
    '<div style="font-family:system-ui,sans-serif;padding:2rem;color:#689F38;font-weight:600">Completing sign-in…</div>';
} else {
  // "New design" flag: always on unless the build sets REACT_APP_ENABLE_V1=true
  // (rollback, then ?ui=v2 / ?ui=v1 are read and persisted). Either way the
  // param is stripped from the address and <html> is marked before anything
  // renders (config/uiVersion.js).
  initUiVersion();
  root.render(
    <React.StrictMode>
      <ErrorBoundary>
        <AuthProvider>
          <App />
        </AuthProvider>
      </ErrorBoundary>
    </React.StrictMode>
  );
}
